import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { userApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const user = createAsyncThunk('user', async (payload) => {
  return await userApi(payload);
});

const userSlice = createSlice({
  name: 'user', // Unique Name
  initialState,
  reducers: {
    userReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(user.pending, (state) => {
        state.status = 'loading';
        state.token = '';
      })
      .addCase(user.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data;
      })
      .addCase(user.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { userReset } = userSlice.actions;

export default userSlice.reducer;
